"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var pbkdf2_1 = tslib_1.__importDefault(require("pbkdf2"));

function pbkdf2(_x, _x2, _x3, _x4) {
  return _pbkdf.apply(this, arguments);
}

function _pbkdf() {
  _pbkdf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(password, salt, iterations, dklen) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              pbkdf2_1.default.pbkdf2(password, salt, iterations, dklen, 'sha256', function (err, result) {
                if (err) {
                  reject(err);
                } else {
                  resolve(result);
                }
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pbkdf.apply(this, arguments);
}

exports.pbkdf2 = pbkdf2;